import React, { useRef, useState } from "react";
import { CopyIcon, TrashIcon, UploadIcon } from "../Icons";
import { Button } from "antd";
import PolicyModal from "../Modals/PolicyModal";

const FileUpload = () => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [files, setFiles] = useState([]);

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFiles(files);
    }
  };

  const handleFiles = (files) => {
    setFiles(files);
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const isFiles = files?.length > 0;
  console.log("🚀 ~ FileUpload ~ isFiles:", isFiles);

  const handleDelete = (event) => {
    event.stopPropagation();
  };

  const handleUpload = (event) => {
    event.stopPropagation();
  };

  return (
    <>
      {isFiles ? (
        <div
          className={`uploadContainer   ${
            isFiles ? "afterUpload" : "beforeUpload"
          }`}
        >
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={(e) => handleFiles(e.target.files)}
            multiple
          />
          <div className="afterUploadBox">
            <p className="uploadingText">Uploading 2 files</p>
            {["", ""].map(() => {
              return (
                <div className="fileCard">
                  <div>
                    <CopyIcon /> <p>dsc_0463.pdf</p>
                  </div>
                  <span onClick={handleDelete}>
                    <TrashIcon />
                  </span>
                </div>
              );
            })}
            <div className="uploadButtonBox">
              {/* <Button type="primary" onClick={handleUpload}>
                Upload
              </Button> */}
              <PolicyModal />
            </div>
            <div
              className={`browseText ${isDragging ? "dragging" : ""}`}
              onDragOver={(e) => e.preventDefault()}
              onDragEnter={() => setIsDragging(true)}
              onDragLeave={() => setIsDragging(false)}
              onDrop={handleDrop}
              onClick={handleBrowseClick}
            >
              <p>
                Drag & drop files or <span>Browse</span>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`uploadContainer  ${isDragging ? "dragging" : ""} ${
            isFiles ? "afterUpload" : "beforeUpload"
          }`}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={() => setIsDragging(true)}
          onDragLeave={() => setIsDragging(false)}
          onDrop={handleDrop}
          onClick={handleBrowseClick}
        >
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={(e) => handleFiles(e.target.files)}
            multiple
          />
          <div className="uploadBox">
            <div className="uploadIcon">
              <UploadIcon />
            </div>
            <p className="uploadText">
              Drag & drop files or <span>Browse</span>
            </p>
            <p className="uploadNote">
              Files must be JPEG, PNG, PDF, Text,
              <br />
              Excel, Word and up to 40MB
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default FileUpload;
